<div class="container-fluid h-75">
  <div class="page-head">
    <h1 class="page-title">{{ title }}</h1>
    <div class="action-row">
      <div class="form-check d-flex align-items-center m-0">
        <input
          class="form-check-input me-1"
          id="showDeleted"
          type="checkbox"
          (change)="onShowDeleteChange()"
        />
        <label class="form-check-label m-0" for="showDeleted"
          >Show deleted?</label
        >
      </div>
      @if (showAddUserButton()) {
        <button class="btn btn-primary" (click)="addEditUser()">
          Add user
        </button>
      }
    </div>
  </div>

  <div class="row grid-container">
    <app-users-grid
      [gridName]="'UsersGrid'"
      [suppliedQueryData]="suppliedGridQueryData"
      [ColumnIdToColumnActions]="ColumnIdToColumnActions"
      [FilterModel]="FilterModel"
      [(reloadGridData)]="reloadGrid"
      (actionEvent)="action($event)"
    ></app-users-grid>
  </div>
</div>
